module.exports = __webpack_public_path__ + "static/media/fixed_voice_select_arrow.dc3bd797.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/fixed_voice_select_arrow.svg
// module id = 3170
// module chunks = 0